import React from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from "react-i18next";
import { InputLabel, TextField, Size } from "@laerdal/life-react-components";
import styled from 'styled-components';

const InputCell = styled.div`
    width: 100%;
    align-self: stretch;
    display: flex;
    padding-bottom: 4px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex-grow: 1;

    div {
        width: 100%;
    }

    textarea {
        width: calc(100% - 32px) !important;
        min-height:100px;
    }
`;

interface FormFieldProps {
    name: string;
    control: Control<any>;
    errors: FieldErrors<any>;
    label: string;
    placeholder?: string;
    required?: boolean;
    testId?: string;
    disabled?: boolean;
    size?: Size.Small | Size.Medium;
}

export const FormTextField: React.FC<FormFieldProps> = ({
    name,
    control,
    errors,
    label,
    placeholder,
    required = false,
    testId,
    disabled = false,
    size = Size.Small,
}) => {
    const { t } = useTranslation("cases");

    if (disabled) {
        return (
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <input type="hidden" name={field.name} value={field.value ?? ''} />
                )}
            />
        );
    }

    return (
        <InputCell>
            <InputLabel inputId={name} text={label} size={size} required={required} />
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        id={name}
                        data-testId={testId || name}
                        validationMessage={errors[name]?.message as string}
                        placeholder={placeholder}
                        size={size}
                    />
                )}
            />
        </InputCell>
    );
};
